"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var brandCenter;
        (function (brandCenter) {
            var branding;
            (function (branding) {
                class InitArgs {
                    constructor() {
                        this.canSave = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    refreshPreviewTitle();
                    refreshLoginBody();
                    renderTheme(String($('#BrandApp_CommonBranding_UiTheme').val()));
                    refreshLoginBody();
                    appn.minicolors.init(function () {
                        refreshLoginBody();
                    }, args.canSave, $('.colorPickerLeftBottom'), 'bottom left');
                    appn.minicolors.init(function () {
                        refreshLoginBody();
                    }, args.canSave, $('.colorPickerRightBottom'), 'bottom right');
                    addEvents();
                }
                branding.init = init;
                function refreshPreviewTitle() {
                    const title = [];
                    for (let i = 1; i < 4; i++) {
                        title[i - 1] = String($(`#AppConfig_TitleColor${i}`).val());
                        if (title[i - 1].length === 0)
                            title[i - 1] = '#FFFFFF';
                    }
                    const gradientBody = `linear-gradient(top, ${title[0]} 0%, ${title[1]} 60%, ${title[2]} 100%)`;
                    const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=\'${title[0]}\', endColorstr=\'${title[2]}\');/*For IE7-8-9*/`;
                    $.each([appn.emptyString, ' - o - ', ' - moz - ', ' - webkit - ', ' - ms - '], function () {
                        $('.previewTitle').css({ 'background-image': this + gradientBody });
                    });
                    $('.previewTitle').css({ filter: ieGradient });
                }
                function refreshLoginBody() {
                    const loginScreenColorBg = [];
                    for (let i = 1; i < 4; i++) {
                        loginScreenColorBg[i - 1] = String($(`#BrandApp_CommonBranding_ColorBg${i}`).val());
                        if (loginScreenColorBg[i - 1].length === 0)
                            loginScreenColorBg[i - 1] = '#FFFFFF';
                    }
                    const gradientBody = `linear-gradient(top, ${loginScreenColorBg[0]} 0%, ${loginScreenColorBg[1]} 60%, ${loginScreenColorBg[2]} 100%)`;
                    const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=\'${loginScreenColorBg[0]}\', endColorstr=\'${loginScreenColorBg[2]}\');/*For IE7-8-9*/`;
                    $.each([appn.emptyString, '-o-', '-moz-', '-webkit-', '-ms-'], function () {
                        $('.deviceSkin-content-wrapper-branding-loginscreen').css({ 'background-image': this + gradientBody });
                    });
                    $('.deviceSkin-content-wrapper-branding-loginscreen').css({ filter: ieGradient });
                    renderBtnColor('btn-signin', String($('#BrandApp_CommonBranding_ColorBtnLogin').val()));
                    renderBtnColor('btn-okta', String($('#BrandApp_CommonBranding_ColorBtnOktaSSO').val()));
                    renderBtnColor('btn-ping', String($('#BrandApp_CommonBranding_ColorBtnPingSSO').val()));
                    renderBtnColor('btn-azure', String($('#BrandApp_CommonBranding_ColorBtnAzureSSO').val()));
                    renderBtnColor('btn-newuser', String($('#BrandApp_CommonBranding_ColorBtnNewUser').val()));
                    renderBtnColor('btn-defaultbtn', String($('#BrandApp_CommonBranding_ColorBtnDefault').val()));
                    renderBtnColor('btn-logout', String($('#BrandApp_CommonBranding_ColorBtnLogout').val()));
                    $('.btn-forgotlink').css('color', String($('#BrandApp_CommonBranding_ColorForgotLink').val()));
                }
                function renderBtnColor(btnClass, color) {
                    $('.' + btnClass).css('background-color', color);
                }
                function renderTheme(themeType) {
                    if (themeType === 'Flat')
                        $('.deviceSkin').removeClass('uiTheme-classic').removeClass('uiTheme-flat').addClass('uiTheme-flat');
                    else
                        $('.deviceSkin').removeClass('uiTheme-classic').removeClass('uiTheme-flat').addClass('uiTheme-classic');
                }
                function addEvents() {
                    $('#BrandApp_CommonBranding_UiTheme').off().on('change', function (e) {
                        renderTheme(String($(this).val()));
                        appn.select.init({
                            selector: '.propertiesPane.rightPropertiesPane select#BrandApp_CommonBranding_UiTheme'
                        });
                    });
                    $('span').on('click', 'a.viewImage', function (event) {
                        event.preventDefault();
                        appn.dialog.viewMediaFromElement($(this));
                    });
                    appn.minicolors.toggleColorPickerMulti();
                }
            })(branding = brandCenter.branding || (brandCenter.branding = {}));
        })(brandCenter = views.brandCenter || (views.brandCenter = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
